var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSoundWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m0.80769 5.6c-0.48462 0-0.80769 0.32-0.80769 0.8v3.2c0 0.48 0.32308 0.8 0.80769 0.8 0.48462 0 0.80769-0.32 0.80769-0.8v-3.2c0-0.48-0.32308-0.8-0.80769-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m4.0385 4c-0.48462 0-0.80769 0.32-0.80769 0.8v6.4c0 0.48 0.32308 0.8 0.80769 0.8 0.48462 0 0.80769-0.32 0.80769-0.8v-6.4c0-0.48-0.32308-0.8-0.80769-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m7.2692 0c-0.48462 0-0.80769 0.32-0.80769 0.8v14.4c0 0.48 0.32308 0.8 0.80769 0.8 0.48462 0 0.80769-0.32 0.80769-0.8v-14.4c0-0.48-0.32308-0.8-0.80769-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m10.5 5.6c-0.48462 0-0.80769 0.32-0.80769 0.8v3.2c0 0.48 0.32308 0.8 0.80769 0.8s0.80769-0.32 0.80769-0.8v-3.2c0-0.48-0.32308-0.8-0.80769-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m13.731 2.4c-0.48462 0-0.80769 0.32-0.80769 0.8v9.6c0 0.48 0.32308 0.8 0.80769 0.8s0.80769-0.32 0.80769-0.8v-9.6c0-0.48-0.32308-0.8-0.80769-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m16.962 0c-0.48462 0-0.80769 0.32-0.80769 0.8v14.4c0 0.48 0.32308 0.8 0.80769 0.8 0.48462 0 0.80769-0.32 0.80769-0.8v-14.4c0-0.48-0.32308-0.8-0.80769-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.192 5.6c-0.48462 0-0.80769 0.32-0.80769 0.8v3.2c0 0.48 0.32308 0.8 0.80769 0.8s0.80769-0.32 0.80769-0.8v-3.2c0-0.48-0.32308-0.8-0.80769-0.8z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundWave);
export default __webpack_public_path__ + "static/media/icon_sound_wave.134a2d45804a07b96e112d32479fa720.svg";
export { ForwardRef as ReactComponent };